import React from 'react'
import { FaSquareCheck } from 'react-icons/fa6'

export default function TutorialSection({ title, text }) {
  return (
    <div>
      <h6 className='flex flex-row gap-[8px] items-center mb-0'>
        <FaSquareCheck color='green' size={20} className='shrink-0' />
        <span className='break-words'>{title}</span>
      </h6>

      <p className='text-base pl-6 mt-0 mb-6'>{text}</p>
    </div>
  )
}
